<div id="larger-screens" class="change-facility-grid">
  <div [ngStyle]="dataService.windowInnerHeightVH$(0.5, 0) | async">
    <ag-grid-angular
      #agGrid
      style="width: 100%; height: 100%"
      class="ag-theme-balham invSummaryGrid--header"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [gridOptions]="gridOptions"
      [suppressHorizontalScroll]="true"
    >
    </ag-grid-angular>
  </div>
</div>
